// ABOUTME: Dashboard-mode BOUNDED pivot cell — top/bottom/movers reduced to N rows. Reads the pre-aggregated
// ABOUTME: rows the viewer already loaded (savedreportpivotrow, via getDashboardById) and slices to variant/N.
import { Box, ButtonBase, useTheme } from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../theme";
import { ENV_TYPES } from "../../Sidebar";
import Text from "../../../theme/text/Text";
import Subheading from "../../../theme/text/Subheading";
import { dashboardPivotVariants } from "../builder/dashboardEnums";

const N = (v) => Number(v) || 0;

// Slice the pre-aggregated rows to the cell's variant + N: top/bottom by total, movers by |Δ%|.
const sliceRows = (rows, variant, n) => {
    const sorted = [...(rows || [])];
    if (variant === dashboardPivotVariants.BOTTOM) sorted.sort((a, b) => N(a.total) - N(b.total));
    else if (variant === dashboardPivotVariants.MOVERS) sorted.sort((a, b) => Math.abs(N(b.delta)) - Math.abs(N(a.delta)));
    else sorted.sort((a, b) => N(b.total) - N(a.total));
    return n ? sorted.slice(0, n) : sorted;
};

// `data` is this report's pre-agg payload from the viewer: { kind:"pivot", rows:[{ rowKey, rowName, total, delta }] }.
export const RhDashboardPivotBounded = ({ chart, data, isTopRow }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const navigate = useNavigate();
    // Both environments run the same hub, only under their own route prefix.
    const selectedEnvironmentType = useSelector((state) => state.settings.environment.selectedEnvironmentType);
    const envPrefix = selectedEnvironmentType === ENV_TYPES[200] ? "/relation" : "/warehouse";
    const isDark = theme.palette.mode === "dark";

    const name = chart?.name;
    // Clicking the icon drills into the full live report at /stockhubbi/report/:id.
    const reportId = chart?.reportId;
    const rows = sliceRows(data?.rows, chart?.variant, chart?.n);

    return (
        <Box
            sx={{
                width: 1,
                flex: 1,
                display: "flex",
                flexDirection:
                "column",
                gap: 2,
                background: isTopRow ? theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0] : null,
                borderRadius:4,
                p:2,
            }}
        >
            <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                <Box sx={{ flex: 1 }}>
                    <Subheading>{name}</Subheading>
                    <Text light>{t(chart?.variant)} {chart?.n}</Text>
                </Box>
                {reportId != null && (
                    <ButtonBase
                        onClick={() => navigate(`${envPrefix}/stockhubbi/report/${reportId}`)}
                        sx={{
                            width: 32,
                            height: 32,
                            borderRadius: 5,
                            color: colors.txt["secondary"],
                            "&:hover": { background: isDark ? colors.grey[300] : colors.grey[100], color: colors.txt["primary"] },
                        }}
                    >
                        <ArrowOutwardIcon fontSize="small" />
                    </ButtonBase>
                )}
            </Box>
            <Box>
            {rows.map((r, i) => (
                <Box key={i} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", py: 0.5, borderBottom: `1px solid ${isDark ? colors.grey[300] : colors.grey[100]}` }}>
                    <Text sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", mr: 2 }}>{r.rowName}</Text>
                    <Text semibold sx={{ flexShrink: 0 }}>{r.total}</Text>
                </Box>
            ))}
            </Box>
        </Box>
    );
};
